// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202603051405/js/" + chunkId + "." + {"44":"da68a379","225":"073fed20","481":"5872a086","486":"e69abdac","770":"08462420"}[chunkId] + ".0.1065593350837144.chunk.js";
};